<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Listado de eps registradas en el sistema</h4>
      <br />
    </div>
    <div class="col-md-12 card">
      <div class="card-content row">
        <div class="col-sm-3">
          <button class="btn btn-primary btn-sm" @click="abrirModal()">
            <i class="ti-plus"></i> Nueva EPS
          </button>
        </div>
        <div class="col-sm-9">
          <label>
            <input
              type="search"
              style="width: 220%"
              class="form-control"
              placeholder="Buscar eps..."
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </label>
          <div class="pull-right">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-sm-12">
          <br />
          <el-table
            class="table-striped"
            :data="queriedData"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              else
            >
            </el-table-column>
            <el-table-column :min-width="100" fixed="right" label="Estado">
              <template slot-scope="props">
                <p v-if="props.row.EpsEst == 1">activa</p>
                <p v-else>Inactiva</p>
              </template>
            </el-table-column>
            <el-table-column :min-width="60" fixed="right" label="Rango">
              <template slot-scope="props">
                <p
                  v-if="props.row.EpsTip == 1"
                  slot="title-label"
                  class="label label-warning"
                >
                  EPS
                </p>
                <p
                  v-else-if="props.row.EpsTip == 2"
                  slot="title-label"
                  class="label label-success"
                >
                  Prepagada
                </p>
                <p v-else slot="title-label" class="label label-info">Poliza</p>
              </template>
            </el-table-column>
            <el-table-column :min-width="120" fixed="right" label="Régimen">
              <template slot-scope="props">
                <span
                  v-if="props.row.EpsReg == 1"
                  slot="title-label"
                  class="label label-warning"
                >
                  Contributivo
                </span>
                <span
                  v-else-if="props.row.EpsReg == 2"
                  slot="title-label"
                  class="label label-danger"
                >
                  Subsidiado
                </span>
                <span v-else slot="title-label" class="label label-success">
                  Contributivo y Subsidiado
                </span>
              </template>
            </el-table-column>
            <el-table-column :min-width="40" fixed="right" label="Acc">
              <template slot-scope="props">
                <button
                  v-if="props.row.EpsEst == 2"
                  class="btn btn-simple btn-xs btn-info btn-icon check"
                  @click="activar(props.row)"
                >
                  <i class="ti-check"></i>
                </button>
                <button
                  v-else
                  class="btn btn-simple btn-xs btn-warning btn-icon edit"
                  @click="desactivar(props.row)"
                >
                  <i class="ti-close"></i>
                </button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <br />
          <p class="category">
            Mostrando del {{ from + 1 }} al {{ to }} de {{ total }} registros
          </p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          >
          </p-pagination>
        </div>
      </div>
    </div>
    <!-- 
            primer modal-->
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :class="{ mostrar: modalRegistrar }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header CM" style="padding: 8px">
            <strong class="modal-title" id="exampleModalLongTitle">
              <i class="fa fa-graduation-cap"></i>
              Nueva EPS
            </strong>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="agregarEntidad">
              <div class="row">
                <div class="col-md-6 col-xs-12">
                  <label for="">NIT:</label>
                  <input type="text" v-model="nit" class="form-control" />
                </div>
                <div class="col-md-6 col-xs-12">
                  <label for="">Nombre:</label>
                  <input
                    type="text"
                    v-model="nombreEps"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label for="">Nombre corto:</label>
                  <input
                    type="text"
                    v-model="nombreCorto"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-6">
                  <label for="" style="padding-top: 11px">Tipo:</label> <br />
                  <div class="row">
                    <div class="col-md-4">
                      <input v-model="tipo" value="1" type="radio" />
                      <label for="">EPS</label>
                    </div>
                    <div class="col-md-4">
                      <input v-model="tipo" value="2" type="radio" />
                      <label for="">Prepag.</label>
                    </div>
                    <div class="col-md-4">
                      <input v-model="tipo" value="3" type="radio" />
                      <label for="">Póliza</label>
                    </div>
                  </div>
                  <br />
                  <div class="row" v-if="tipo == 1">
                    <div class="col-12">
                      <label for="">Régimen:</label>
                    </div>
                    <br />
                    <div class="col-md-4">
                      <input type="radio" value="1" v-model="regimen" />
                      <label for="">Contri.</label>
                    </div>
                    <div class="col-md-4">
                      <input type="radio" value="2" v-model="regimen" />
                      <label for="">Subsi.</label>
                    </div>
                    <div class="col-md-4">
                      <input type="radio" value="3" v-model="regimen" />
                      <label for="">Ambos</label>
                    </div>
                  </div>
                </div>
              </div>
              <br /><br />

              <center>
                <button type="submit" class="btn btn-primary btn-sm">
                  <i class="fa fa-plus"> </i> Agregar Entidad
                </button>
                <button
                  type="button"
                  @click="limpiarFormulario()"
                  class="btn btn-danger btn-sm"
                >
                  <i class="fa fa-history"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  @click="modalRegistrar = 0"
                >
                  Cancelar
                </button>
              </center>
            </form>
          </div>
          <center></center>
          <br />
        </div>
      </div>
    </div>
    <!-- fin primer modal -->
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

export default {
  data() {
    return {
      token: localStorage.getItem("token"),
      nombreEps: "",
      nombreCorto: "",
      nit: 0,
      tipo: 1,
      estado: "",
      modalAgregar: false,
      regimen: 1,
      ip: "https://avanti-erp.com/",
      modalRegistrar: 0,
      // notificaciones
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },

      //   tabla
      pagination: {
        perPage: 7,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["EpsNom"],
      tableColumns: [
        {
          prop: "EpsNom", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
          label: "Nombre", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
          minWidth: 150, //ANCHO DE LA COLUMNA
        },
        {
          prop: "EpsNomCor", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
          label: "Nombre corto", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
          minWidth: 75, //ANCHO DE LA COLUMNA
        },
        {
          prop: "EpsNit",
          label: "Nit",
          minWidth: 90,
        },
      ],
      arrayEntidad: [],
    };
  },
  components: {
    PPagination,
  },
  computed: {
    pagedData() {
      return this.arrayEntidad.slice(this.from, this.to);
    },
    /*
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.arrayEntidad.length;
        return this.pagedData;
      }
      let result = this.arrayEntidad.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.arrayEntidad.length;
      return this.arrayEntidad.length;
    },
  },
  methods: {
    agregarEntidad() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      let vm = this;
      var url = this.ip + "api/nuevaEps";
      axios
        .post(
          url,
          {
            EpsNom: this.nombreEps,
            EpsNomCor: this.nombreCorto,
            EpsNit: this.nit,
            EpsTip: this.tipo,
            EpsReg: this.regimen,
          },
          config
        )
        .then((response) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span>-<b> Objetivo registrado con éxito!</b>.</span>`,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.listarEntidad();
          this.nombreEps = "";
          this.nombreCorto = "";
          this.nit = 0;
          this.tipo = 1;
          this.regimen = 1;
          this.modalRegistrar = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    listarEntidad() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      let vm = this;
      var url = this.ip + "api/eps";
      axios
        .get(url, config)
        .then((response) => {
          vm.arrayEntidad = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    desactivar(entidad = []) {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      let vm = this;
      var url = this.ip + "api/desactivar";
      axios
        .put(
          url,
          {
            id: entidad.EpsCod,
          },
          config
        )
        .then((response) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span>-<b> Eps desactivada con éxito!</b>.</span>`,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          vm.listarEntidad();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    activar(entidad = []) {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      let vm = this;
      var url = this.ip + "api/activar";
      axios
        .put(
          url,
          {
            id: entidad.EpsCod,
          },
          config
        )
        .then((response) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span>-<b> Eps activada con éxito!</b>.</span>`,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          vm.listarEntidad();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    limpiarFormulario() {
      this.nombreEps = "";
      this.nombreCorto = "";
      this.nit = 0;
      this.tipo = 1;
    },
    abrirModal() {
      this.modalRegistrar = 1;
      this.nombreEps = "";
      this.nombreCorto = "";
      this.tipo = "";
      this.regimen = 1;
    },
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push('/');
    } else {
      this.listarEntidad();
    }
  },
};
</script>  
<style>
.mostrar {
  display: list-item !important;
  opacity: 1 !important;
  position: absolute !important;
  background-color: #3c29297a;
  padding-top: 15%;
}
.modal-content {
  width: 100% !important;
  position: absolute !important;
}

.tabs {
  cursor: pointer;
}
.titulo {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Mantenimiento/mantenimiento-eps.vue